exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".checkout-wrapper--e6Cqb{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}\n", "", {"version":3,"sources":["/workspace/src/widget/new-event-layouts/mobile/checkout-only/styles.scss"],"names":[],"mappings":"AAAA,yBACE,oBAAA,oBAAA,aACA,UAAW,CAAA","file":"styles.scss","sourcesContent":[".checkout-wrapper {\n  display: flex;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"checkout-wrapper": "checkout-wrapper--e6Cqb",
	"checkoutWrapper": "checkout-wrapper--e6Cqb"
};